import { PermsService } from './../../../services/utils/perms.service';
import { Observable } from 'rxjs';
import { PermissionConfiguration, ApiMethods } from './../../../models/permission.model';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { DataTableCustomButton } from '../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { DataTableField } from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';
import { StoreCommonService } from '../../../services/store/store-common.service';

@Component({
  selector: 'app-store-common',
  templateUrl: './store-common-component.html'
})
export class StoreCommonComponent implements OnInit {

  titles: DataTableField[];
  customButtons: DataTableCustomButton[];
  activeView = '';
  listData: any;
  public pagination = KontableComponent.ServerPagination;
  public newDataAvailable = false;
  tryStimulsoft: boolean;

  // Mostra tasto cancellazione negozio
  public deleteStorePermission: boolean;
  public deleteStorePermissionCheck: PermissionConfiguration;

  constructor (
    public svc: StoreCommonService,
    private translate: TranslateService,
    protected router: Router,
    private svcNotification: MessageService,
    private permSrv: PermsService
  ) {

    this.deleteStorePermissionCheck = {
      ms_base: 'koncentro-common',
      operation: 'store',
      method: ApiMethods.DELETE
    }

  }

  ngOnInit() {
    // test stimulsoft button
    this.tryStimulsoft = false;
    this.deleteStorePermission = false;

    let obDeleteStorePermCheck: Observable<any>;

    obDeleteStorePermCheck = this.permSrv.check(this.deleteStorePermissionCheck);

    obDeleteStorePermCheck.subscribe(res => this.deleteStorePermission = res);

  }

  delete (entry): void {
    this.svc.delete(entry['id']).subscribe(() => {
      this.translate.get(['common.ok', 'common.delete_ok']).subscribe(data => {
        this.svcNotification.add({
          severity: 'information',
          summary: data['common.ok'],
          detail: data['common.delete_ok']
        });
      });

      this.newDataAvailable = true;
    });
  }

  addStore (event) {
    this.router.navigate(['/store-common-form'])
  }

  editStore(event) {
    this.router.navigate(['/store-common-form', event.id]);
  }

  save(event) {
    console.log(event);
    if (this.svc.editing == null) {
      this.svc.post(event).subscribe(() => {
        this.activeView = 'list';
        this.translate.get(['common.ok', 'common.save_ok']).subscribe(data => {
          this.svcNotification.add({
            severity: 'information',
            summary: data['common.ok'],
            detail: data['common.save_ok']
          });
        });

        this.newDataAvailable = true;
      });
    } else {
      this.svc.put(this.svc.editing.id, event).subscribe(() => {
        this.activeView = 'list';
        this.translate.get(['common.ok', 'common.update_ok']).subscribe(data => {
          this.svcNotification.add({
            severity: 'information',
            summary: data['common.ok'],
            detail: data['common.update_ok']
          });
        });

        this.newDataAvailable = true;
      })
    }
  }

  onClickTryStimulsoft() {
    this.tryStimulsoft = true;
  }

  closeReport(event: string) {
    this.tryStimulsoft = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-common.component.ts